import { React, useState } from "react";
import "./shimmer.css";
import { keyframes } from "@mui/system";
import { Button, styled } from "@mui/material";
import TouchAppIcon from "@mui/icons-material/TouchApp"; 
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"
import { pink } from "@mui/material/colors" 


const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(234, 143, 182, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(234, 143, 182, 0.4);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(234, 143, 182, 0.4);
  }`;

const FancyButtonStyled = styled(Button)(({ theme }) => ({
  backgroundColor: "#EA8FB6",
  color: "white",
  padding: "10px 20px",
  fontSize: "1rem",
  fontWeight: "bold",
  borderRadius: "25px",
  textTransform: "none",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    backgroundColor: "#D67A9D",
    transform: "translateY(-3px)",
    boxShadow: "0 4px 8px rgba(234, 143, 182, 0.5)",
  },
  "&:active": {
    transform: "translateY(-1px)",
    boxShadow: "0 2px 4px rgba(234, 143, 182, 0.5)",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: "25px",
    animation: `${pulseAnimation} 2s infinite`,
  },
}));

const DownloadCalendar = () => {
  const [isHovered, setIsHovered] = useState(false);

  // Path to your .ics file
  const icsFilePath = "wedding-events.ics"; // Ensure the file is placed in the public folder

  const handleDownload = () => {
    // Create an anchor element to trigger the download
    const link = document.createElement("a");
    link.href = icsFilePath;
    link.download = "wedding-events.ics"; // Set the filename for the downloaded file
    link.click(); // Trigger the download
    handleClose();
  };

  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div style={{ display: "flex", margin: "10px", alignItems: "center", justifyContent: "center", gap: "6px"
     }}>
      <FancyButtonStyled
        onClick={handleClickOpen}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <TouchAppIcon/>
        <span className="button-text">લગ્ન કાર્યક્રમ કૅલેન્ડરમાં સેવ કરો  </span>        
        <span className="shimmer-effect"></span>
      </FancyButtonStyled>
      <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          background: "linear-gradient(135deg, #FFF0F5, #FFB6C1)",
          borderRadius: "16px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        style={{
          color: "#D81B60",
          fontSize: "24px",
          fontWeight: "bold",
          textAlign: "center",
          padding: "24px",
          borderBottom: "1px solid rgba(216, 27, 96, 0.2)",
          fontFamily: "Arial, sans-serif",
        }}
      >
        વિશેષ નોંધ
      </DialogTitle>
      <DialogContent>
        <p
          style={{
            padding: "24px",
            color: "#880E4F",
            fontSize: "16px",
            lineHeight: "1.6",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
          }}
        >
          ડાઉનલોડ બટન પર ક્લિક કર્યા પછી , ડાઉનલોડ થયેલ ફાઇલ ઓપન કરીને સેવ કરવી, જેથી આપશ્રી ને સમયસર શુભ પ્રસંગો ની જાણ રહી શકે.
        </p>
      </DialogContent>
      <DialogActions
        style={{
          padding: "16px 24px 24px",
          justifyContent: "center",
        }}
      >
        <Button
          onClick={handleDownload}
          style={{
            backgroundColor: "#D81B60",
            color: "white",
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "bold",
            borderRadius: "30px",
            border: "none",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 6px rgba(216, 27, 96, 0.2)",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <CalendarTodayIcon style={{ fontSize: "20px" }} />
          ડાઉનલોડ કરો
        </Button>
      </DialogActions>
    </Dialog>
    </div>
  );
};

export default DownloadCalendar;
